import { FC, SVGProps } from 'react';

const CustomFieldDateIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.28814 6.90392C4.11754 5.7946 4.93807 4.78925 6.01404 4.78925H14.4474C15.3058 4.78925 16.0373 5.44009 16.1733 6.3251L17.4774 14.8048C17.6481 15.9141 16.8275 16.9194 15.7515 16.9194H7.31816C6.45975 16.9194 5.72837 16.2686 5.59226 15.3836L4.28814 6.90392Z"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5005 4.78925H5.55254C4.69413 4.78925 3.96274 5.44009 3.82664 6.3251L2.52252 14.8048C2.35191 15.9141 3.17244 16.9194 4.24842 16.9194H6.96857"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.40137 6.25364C7.56034 6.44542 7.665 6.41576 7.87323 6.41576C8.41625 6.41576 8.8565 5.65125 8.8565 4.70819C8.8565 3.76512 8.41625 3.00061 7.87323 3.00061C7.58345 3.00061 7.41385 3.03453 7.23389 3.38089"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3251 6.25364C12.4841 6.44542 12.5888 6.41576 12.797 6.41576C13.34 6.41576 13.7803 5.65125 13.7803 4.70819C13.7803 3.76512 13.34 3.00061 12.797 3.00061C12.5072 3.00061 12.3376 3.03453 12.1577 3.38089"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6499 14.0225L12.2899 9.56018H9.47559"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CustomFieldDateIcon;
